import React from 'react';
import styled from 'styled-components';
import { Label } from 'reactstrap';

export default styled(({ isChosen, ...rest }) => <Label {...rest} />)`
  display: block;
  padding: 0.5rem;
  cursor: pointer;
  font-size: 0.75rem;

  &:hover,
  &:focus {
    background: rgba(0, 0, 0, 0.05);
  }

  &:first-child {
    &:hover,
    &:focus {
      border-radius: 0.25rem 0.25rem 0 0;
    }
  }
  &:last-child {
    &:hover,
    &:focus {
      border-radius: 0 0 0.25rem 0.25rem;
    }
  }

  && + && {
    margin-top: 0.25rem;
  }
`;
